import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Section from '../../section';
import Container from '../../container';
import Waves from '../../waves';
import TextWave from '../../text-wave';
import ListForm from '../../forms/list-form';
import RenderMd from '../../render-md';

const PartnersFormSection = props => (
  <Fragment>
    <Section dark id="become-a-partner">
      <Container>

        <SectionContent>
          <TextWave>
            <SectionTitle>{props.title}</SectionTitle>
          </TextWave>
          <RenderMd source={props.description} />
        </SectionContent>

        <ListForm
          formTitle={props.formTitle}
          form={props.form}
          listId="1"
          formSuccess={props.formSuccess}
        />

      </Container>
    </Section>

    <WaveWrap>
      <Waves
        position="bottom"
        alignment="bottom"
        height={550}
      />
    </WaveWrap>
  </Fragment>
);

const SectionTitle = styled.h2`
  margin-bottom: 80px;

  ${screen.below(bp.mobile, `
    margin-bottom: 60px;
  `)}
`;

const SectionContent = styled.div`
  text-align: center;

  p {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const WaveWrap = styled.div`
  position: relative;
  height: 172px;
  z-index: -1;

  ${screen.below(bp.mobile, `
    height: 120px;
  `)}
`;

PartnersFormSection.propTypes = {
  formTitle: PropTypes.string,
  form: PropTypes.object,
  formSuccess: PropTypes.object,
};

export default PartnersFormSection;
